import * as React from 'react';
import {
    Col,
    Container,
    Row,
    Table
} from 'reactstrap';

import DeleteIcon from '@mui/icons-material/Delete';

import {
    CreateUserRequest,
    PortalTextCommon,
    PortalTextSettings,
    RoleResponse,
} from '../../../Models/Api/strongbox.financialportal';
import { FullUserNameFromComponents } from '../../../Utils/UserUtils';
import { AddUsersMode, GetRoleDescriptionFromId } from './CommonUser';

type Props = {
    availableRoles: RoleResponse[];
    users: CreateUserRequest[];
    removeUser: (userIndex: number) => void;
    editMode: AddUsersMode;
    settingsText?: PortalTextSettings;
    commonText?: PortalTextCommon;
}

export const InvitedUserList: React.FC<Props> = (props): React.ReactElement => {
    const getPermissionsText = (user: CreateUserRequest): string => {
        if (!(user.roleIds && props.availableRoles)) {
            console.error('Unexpected error, there are no roleIds or available roles InvitedUserList:getPermissionsText');
            return props.commonText?.unknown || '';
        }
        let result = '';
        let first = true;
        user.roleIds.forEach((roleId, index) => {
            const roleDescription = props.availableRoles.find(roleDesc => roleDesc.id === roleId);
            if (!!roleDescription) {
                const displayName = GetRoleDescriptionFromId(roleId, props.settingsText);
                result += (first ? `${displayName}` : `, ${displayName}`);
                first = false;
            }
        });
        return result;
    }

    const titlePrompt = React.useMemo(() => {
        return props.editMode === 'editrequired' ? (props.settingsText?.addUserUsersToInvite || '') : (props.settingsText?.addUserOptionalUserData || '');
        // These are the dependencies I actually want
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [props.editMode]);

    const instructionText = React.useMemo(() => {
        return props.editMode === 'editrequired' ? (props.settingsText?.addUserInviteUsersInstructions || '') : (props.settingsText?.addUserOptionalUserDataInstructions || '');
        // These are the dependencies I actually want
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [props.editMode]);

    return (
        <Container>
            <Row className={'std-form-row'}>
                <h4>{titlePrompt}</h4>
            </Row>
            <Row className={'std-form-row'}>
                {!!props.users.length && (
                    <Col className={'column-list-container'}>
                        <Table className={'invited-user-container'}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{props.settingsText?.addUserNewNamePrompt || ''}</th>
                                    <th>{props.settingsText?.addUserNewEmailPrompt || ''}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.users.map((user, index) => (
                                    <tr key={index.toString()} id={index.toString()}>
                                        <td>
                                            <DeleteIcon
                                                onClick={() => {
                                                    props.removeUser(index);
                                                }}
                                            />
                                        </td>
                                        <td className={'name-container'}>
                                            <div className={'multiline-cell'}>
                                                <span>{FullUserNameFromComponents(user.displayName, user.firstName, user.lastName)}</span>
                                                <span className={'light'}>{getPermissionsText(user)}</span>
                                            </div>
                                        </td>
                                        <td className={'email-container'}>{user.emailAddress}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                )}
                {!props.users.length && (
                    <Col>{instructionText}</Col>
                )}
            </Row>
        </Container>
    );
}
